module.exports = __webpack_public_path__ + "img/selected6-min.a9ea8acd.png";